import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgModel, Validator, AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'epp-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit, Validator {

  @Input() placeholder
  @Input() required = false

  @Input() maxLength = 500

  @Input() value
  @Output() valueChange = new EventEmitter<string>()

  @Input() toBeReset = false
  @Output() toBeResetChange = new EventEmitter<boolean>()

  @ViewChild('ngModel') ngModel: NgModel

  constructor () { }

  // TODO: 还不能反应到表单里，待改进
  validate (control: AbstractControl): ValidationErrors {
    return
  }
  registerOnValidatorChange? (fn: () => void): void {
    // throw new Error('Method not implemented.')
  }

  ngOnInit () {
  }

  reset () {
    this.toBeReset = false
    this.toBeResetChange.emit(this.toBeReset)
    this.value = ''
    this.valueChange.emit(this.value)
  }

}
